<template>
    <section class="container-fluid bg-secondary text-white p-0">
        <form name="PLZ" id="cta" action="" v-on:submit.prevent="submit" class="cta-bar bg-secondary text-white pt-4 pb-2">
            <div class="container">
                <div class="row justify-content-center align-items-center px-3 px-md-0 d-fixed-none">
                    <div class="col-lg-auto text-lg-center mb-3 mb-lg-0">
                        <h2 class="h4 text-uppercase no-deco text-md-center m-0 px-3 px-lg-0 text-white">Finde jetzt das richtige Auto Abo für dich</h2>
                        <ul class="step p-0 d-none d-lg-block">
                            <li class="d-inline mr-1">1. Auto suchen</li>
                            <li class="d-inline mr-1">2. Buchen</li>
                            <li class="d-inline mr-1">3. Flexibel fahren</li>
                        </ul>
                    </div>
                    <!--
                    <div class="col-lg-4 text-center mb-3 mb-lg-0">

                        <div class="input-group input-group-lg">
                            <input type="text" name="location" id="location-input" v-model="location.address" placeholder="Postleitzahl oder Ort" class="form-control border-0">
                            <div class="input-group-append">
                                <button class="input-group-text bg-white border-0" @click="getLocationFromGeoData"><i :class="locationError ? 'fas fa-exclamation-triangle' : 'fas fa-map-marker-alt'"></i></button>
                            </div>
                        </div>
                        <label for="location-input" class="bottom-label d-none d-lg-block">Bitte gib deine Postleitzahl oder Ort ein</label>

                    </div>
                    -->
                    <div class="col-lg-auto text-center px-lg-3 text-center">
                        <a :href="catalogUrl" class="btn btn-primary btn-lg px-5">
                            Auto finden
                        </a>
                        <label for="location-submit" class="bottom-label d-none d-md-block">ohne Anmeldung</label>
                    </div>
                    <div class="col-12 text-center d-lg-none">
                        <ul class="step p-0 my-3">
                            <li class="d-inline mr-1">1. Auto suchen</li>
                            <li class="d-inline mr-1">2. Buchen</li>
                            <li class="d-inline mr-1">3. Flexibel fahren</li>
                        </ul>
                    </div>
                </div>
                <div class="d-fixed">
                    <a :href="catalogUrl" class="btn btn-primary btn-lg btn-block">
                        Jetzt dein Auto finden <i class="fas fa-chevron-right"></i>
                    </a>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    export default {
        name: "CTA-Bar",
        props: ['linkUrl', 'catalogUrl'],
        data(){
            return {
                location: {
                    address: "",
                    latitude: "",
                    longitude: ""
                },
                locationError: ""
            }
        },
        methods: {
            getLocationFromUserInput: function () {
                var self = this;
                var input_address = this.location.address.replace(" ", "+");
                axios.defaults.headers.common = {};
                axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                    params: {
                        address: input_address,
                        key: this.$googleMapsApi
                    }
                }).then(function (response) {
                    var location = response.data.results[0].geometry.location;
                    self.location.longitude = location.lng;
                    self.location.latitude = location.lat;
                    self.address = response.data.results[0].formatted_address;

                    let params = {
                        location: {
                            address: self.location.address,
                            latitude: self.location.latitude,
                            longitude: self.location.longitude
                        }
                    };

                    params.page = 1;
                    var paramsAsUrl = $.param(params);
                    window.location.href = "{{ route('vehicles.catalog') }}?" + paramsAsUrl;

                    window.location.href = self.linkUrl + "?" + paramsAsUrl;
                }).catch(function (error) {
                    console.warn(error);
                });
            },
            getLocationFromGeoData: function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.setLocation, this.showError);
                } else {
                    this.locationError("Geolocation wird nicht unterstützt!");
                }
            },
            setLocation: function (position) {
                var self = this;

                this.location.latitude = position.coords.latitude;
                this.location.longitude = position.coords.longitude;

                var latLng = {
                    lat: parseFloat(this.location.latitude),
                    lng: parseFloat(this.location.longitude)
                };
                var geocoder = new google.maps.Geocoder;
                geocoder.geocode({'location': latLng}, function (results, status) {
                    if (status === 'OK') {
                        self.location.address = results[5].address_components[0].short_name + ' ' + results[5].address_components[1].short_name;
                    } else {
                        console.warn("Fehler im GeoCoder");
                    }
                });
            },
            submit(){
                this.getLocationFromUserInput();
                console.log(this.url);
                //window.location.href = encodeURIComponent(this.route + "?location[longitude]=" + this.location.longitude + "&location[latitude]="+this.location.latitude);
            }
        },
        watch: {
            'location.address'(){
            }
        },
        computed: {
            route(){
                return this.linkUrl;
            }
        },
        mounted(){
        }
    }
</script>

<style scoped>

</style>
